import { Box, CircularProgress } from "@material-ui/core";
import React from "react";

export default function Loader() {
  return (
    <Box
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
